import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../common/ui/Loader';
import GroupMessages from './groupMessages/GroupMessagesContainer';
import ConversationsListItem from './ConversationsListItem';
import UsersService from '../../../services/UsersService';
import ConversationContainer from './ConversationContainer';
import { conversationTypes, directConversationsSubTypes } from '../../../constants/conversations';
import { labels } from '../../../constants/text';
import StartConversationModal from './StartConversationModal';

export default class ConversationsList extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    conversations: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    addAdminLastMessageToList: PropTypes.func.isRequired,
    updateConversationMessagesCount: PropTypes.func.isRequired,
    startConversation: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    convIdfromNotification: PropTypes.number,
    searchWorkersAction: PropTypes.func.isRequired,
    clearWorkersPredictionsList: PropTypes.func.isRequired,
    workersPredictionsList: PropTypes.array.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      activeConversationId: props.convIdfromNotification || null,
      findWorkerModalIsOpen: false
    };
  }

  openWorkerModal = () => {
    this.setState({
      findWorkerModalIsOpen: true
    });
  };

  startNewConversation = workerData => {
    this.closeWorkerModal();
    this.props.startConversation({
      type: directConversationsSubTypes.private,
      users: [workerData.id, this.props.user.userid] // [workerId, employerId]
    }).then(({ conversation_id }) => this.selectConversationChat(conversation_id));
  };

  closeWorkerModal = () => {
    this.setState({
      findWorkerModalIsOpen: false
    });
  };

  splitConversationsBySections () {
    const { conversations } = this.props;
    const conversationsByType = conversations.reduce((accumulator, conversation) => {
      let path = conversation.job_id ? conversationTypes.job : conversationTypes.direct;

      accumulator[path].push(conversation);

      return accumulator;
    }, {
      [conversationTypes.job]: [],
      [conversationTypes.direct]: []
    });

    const sections = [
      {
        title: labels.groupMessages,
        data: conversationsByType[conversationTypes.job],
        type: conversationTypes.job
      },
      {
        title: labels.directMessages,
        data: conversationsByType[conversationTypes.direct],
        type: conversationTypes.direct
      }
    ];

    return sections.filter(function (section) {
      if (section.type === conversationTypes.job) {
        return section.data.length;
      }

      return true;
    });
  }

  getActiveConversationId = () => {
    const { conversations } = this.props;
    let { activeConversationId } = this.state;
    if (conversations.length > 0 && UsersService.isEmployer() && !activeConversationId) {
      activeConversationId = this.splitConversationsBySections()[0].data[0].conversation_id;
    }
    return activeConversationId;
  };

  selectConversationChat = activeConversationId => this.setState({ activeConversationId });

  renderConversationListWithSections = () => {
    const conversationsBySections = this.splitConversationsBySections();
    return conversationsBySections.map(section => {
      return (
        <section key={section.type} className='conversation-section'>
          <h5 className='conversation-section-title text-muted d-flex justify-content-between align-items-center flex-wrap'>
            {section.title}
            { section.type === conversationTypes.direct && (
              <button className='messages-plus-icon' onClick={this.openWorkerModal}>
                <FontAwesomeIcon icon={faPlus} size='lg' />
              </button>
            )}
          </h5>
          {section.data.map(conversation => this.renderConversationListItem(conversation))}
        </section>
      );
    });
  };

  renderConversationListItem = conversation => {
    return (
      <ConversationsListItem
        key={conversation.conversation_id}
        isActive={conversation.conversation_id === this.getActiveConversationId()}
        conversation={conversation}
        addAdminLastMessageToList={this.props.addAdminLastMessageToList}
        updateConversationMessagesCount={this.props.updateConversationMessagesCount}
        selectConversationChat={this.selectConversationChat}
      />
    );
  };

  render () {
    const { isLoading, conversations, updateConversationMessagesCount, searchWorkersAction, workersPredictionsList,
      clearWorkersPredictionsList } = this.props;
    const { findWorkerModalIsOpen } = this.state;
    const activeConversationId = this.getActiveConversationId();
    const isAdmin = UsersService.isAdmin();
    const isEmployer = UsersService.isEmployer();
    return (
      <div>
        { isAdmin && (
          <Fragment>
            <div className='top-header'>
              <div className='page-title'>
                <div className='title-icon'>
                  <FontAwesomeIcon icon={faEnvelope} size='lg' />
                </div>
                <h3>Messages</h3>
              </div>
            </div>
            <GroupMessages path={this.props.path} />
          </Fragment>
        )}
        <div className={`${isEmployer ? 'conversations-chat-wrapper' : ''}`}>
          { isLoading && conversations.length === 0 ? <div className={`${isAdmin ? 'loader-wrapper' : ''}`}><Loader /></div> : (
            <Fragment>
              { conversations.length > 0 ? (
                <main className='conversations-wrapper'>
                  { isAdmin ? conversations.map(conversation => this.renderConversationListItem(conversation))
                    : this.renderConversationListWithSections() }
                  <StartConversationModal
                    isOpen={findWorkerModalIsOpen}
                    closeModal={this.closeWorkerModal}
                    startNewConversation={this.startNewConversation}
                    workersPredictionsList={workersPredictionsList}
                    searchAction={searchWorkersAction}
                    onBlurAction={clearWorkersPredictionsList}
                  />
                </main>
              ) : <p>No conversations yet..</p> }
            </Fragment>
          )}
          { isEmployer && activeConversationId && (
            <ConversationContainer
              showHideChatIcon
              conversationId={activeConversationId}
              updateConversationMessagesCount={updateConversationMessagesCount}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/messages/ConversationsList.js